import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatExpirationDate = (dateString?: string | null): string => {
  if (!dateString) return '';

  const parsedDate = parseISO(dateString);

  if (Number.isNaN(parsedDate.getTime())) {
    console.warn(`Invalid date format received: ${dateString}`);
    return '';
  }

  const friendlyDateRaw = format(parsedDate, "d 'de' MMMM 'de' yyyy", { locale: ptBR });

  const parts = friendlyDateRaw.split(' de ');

  if (parts.length >= 3) {
    const month = parts[1];
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    parts[1] = capitalizedMonth;
    return parts.join(' de ');
  }

  return friendlyDateRaw;
};
